import { render, staticRenderFns } from "./TooltipQuerschnittsberechnung.vue?vue&type=template&id=72b2b4ee&scoped=true&"
import script from "./TooltipQuerschnittsberechnung.vue?vue&type=script&lang=js&"
export * from "./TooltipQuerschnittsberechnung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b2b4ee",
  null
  
)

export default component.exports